import { useAuth } from '@auth/useAuth'
import AppPaths from '@globals/paths'
import { extractSearchParamsForNext } from '@shared/utils/queryParams'
import { Navigate, Outlet, createSearchParams, useLocation } from 'react-router'

export const UserScopeRoutes = () => {
  const { isAuthenticated, isUserScope } = useAuth()
  const { pathname, search } = useLocation()
  // grab the destination url here so that if the user is unauthenticated
  // we can set it as a search parameter for use after the login flow.
  // the tenant login page will handle this and send the user to the
  // intended destination after login, falling back to the Home page if it
  // isn't set.

  // Use only the pathname for next to prevent query params from being nested
  const { nextSearch, extractedSearchParams } = extractSearchParamsForNext(search, ['loginHint'])
  const deepLinkParams = createSearchParams({
    next: pathname + nextSearch,
  })
  const redirectPath = isAuthenticated
    ? `${AppPaths.tenant.me()}?${deepLinkParams}${extractedSearchParams}`
    : `${AppPaths.anon.userLogin()}?${deepLinkParams}${extractedSearchParams}`

  return isUserScope ? <Outlet /> : <Navigate to={redirectPath} />
}
